import Vue from 'vue'
import Vuex from 'vuex'
import Setting from './Setting/index'
import formSteps from './formSteps/index'
import cart from './cart/cart'
import cartOffline from './cart/cartOffline'
Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    Setting,
    formSteps,
    cart,
    cartOffline
  },
  state: {

  },
  mutations: {
  },
  actions: {
  },
  getters: {
  },
  strict: debug
})
